import React, { useState, useEffect, useRef } from 'react';
import './ChatInterface.css';

const OPENAI_API_KEY = "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";

const ChatInterface = ({ navigateTo }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isConnecting, setIsConnecting] = useState(false);
  const [error, setError] = useState(null);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  
  const popularRecipes = [
    {
      id: 1,
      title: 'Göz Yumurta ve Avokadolu Tost',
      image: 'https://images.unsplash.com/photo-1519864600265-abb23847ef2c?auto=format&fit=crop&w=400&q=80',
      time: '20 dk',
      desc: 'Göz Yumurta ve Avokadolu Tost'
    },
    {
      id: 2,
      title: 'Ev Hamburgeri ve Patates Kızartması',
      image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=400&q=80',
      time: '',
      desc: 'Ev Hamburgeri ve Patates Kızartması'
    }
  ];

  useEffect(() => {
    scrollToBottom();
    // Focus input when component mounts
    inputRef.current?.focus();
  }, [messages]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = {
      type: 'user',
      text: input
    };

    setMessages([...messages, userMessage]);
    setInput('');
    setIsConnecting(true);
    setError(null);

    try {
      console.log('OpenAI API\'ye direkt istek gönderiliyor:', input);
      
      // Doğrudan OpenAI API'ye istek gönder
      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${OPENAI_API_KEY}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo',
          messages: [
            { 
              role: 'system', 
              content: 'Sen bir yemek tarifi uzmanısın. Kullanıcının belirttiği malzemelerle yapılabilecek tarifleri vermelisin. Yanıtını şu formatta yapılandır: Önce tarif adı, sonra "Malzemeler:" başlığı altında malzemeler listesi, son olarak "Yapılışı:" başlığı altında adım adım yapılış talimatları. Cevaplarını her zaman Türkçe dilinde vermelisin.' 
            },
            { 
              role: 'user', 
              content: input 
            }
          ],
          max_tokens: 800,
          temperature: 0.7
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(e => ({ error: { message: response.statusText } }));
        throw new Error(`OpenAI API hatası: ${errorData.error?.message || response.statusText}`);
      }

      const data = await response.json();
      console.log('OpenAI API yanıtı alındı:', data);

      if (data.choices && data.choices.length > 0 && data.choices[0].message) {
        const aiResponse = {
          type: 'ai',
          text: data.choices[0].message.content
        };
        setMessages(prev => [...prev, aiResponse]);
      } else {
        throw new Error('API yanıtı beklenmeyen formatta');
      }
    } catch (error) {
      console.error('API isteği sırasında hata:', error);
      const errorMessage = {
        type: 'ai',
        text: `Üzgünüm, bir hata oluştu: ${error.message}. Lütfen daha sonra tekrar deneyin.`
      };
      setMessages(prev => [...prev, errorMessage]);
      setError(`Bağlantı hatası: ${error.message}. Lütfen internet bağlantınızı kontrol edin.`);
    } finally {
      setIsConnecting(false);
      // Focus on input after sending
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  const formatMessage = (message) => {
    // Düz metin olarak göster
    return <div style={{ whiteSpace: 'pre-wrap' }}>{message.text}</div>;
  };

  const clearChat = () => {
    if (messages.length > 0 && window.confirm('Tüm mesajları silmek istediğinizden emin misiniz?')) {
      setMessages([]);
    }
  };

  return (
    <div className="chat-container">
      <div className="popular-recipes-bar">
        <div className="popular-title">En Çok Yapılan Tarifler</div>
        <div className="popular-recipes-scroll">
          {popularRecipes.map(recipe => (
            <div className="popular-recipe-card" key={recipe.id}>
              <img src={recipe.image} alt={recipe.title} className="popular-recipe-img" />
              <div className="popular-recipe-info">
                <div className="popular-recipe-desc">{recipe.desc}</div>
                {recipe.time && <div className="popular-recipe-time"><span role="img" aria-label="clock">🕒</span> {recipe.time}</div>}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="chat-header">
        <button onClick={() => navigateTo('home')} className="back-button">
          Geri
        </button>
        <h2>Yapay Zeka Aşçı</h2>
        {messages.length > 0 && (
          <button onClick={clearChat} className="back-button">
            Temizle
          </button>
        )}
      </div>
      
      <div className="chat-body">
        {messages.length === 0 ? (
          <div className="empty-state">
            <p>Ne pişirmek istiyorsunuz? Hangi malzemelerle tarif istiyorsunuz?</p>
            <p>Örnek: "Evde yumurta, un ve süt var. Ne yapabilirim?"</p>
          </div>
        ) : (
          messages.map((msg, index) => (
            <div key={index} className={`message ${msg.type}-message`}>
              {msg.type === 'user' ? (
                <div>{msg.text}</div>
              ) : (
                formatMessage(msg)
              )}
            </div>
          ))
        )}
        <div ref={messagesEndRef} />
      </div>
      
      <div className="chat-input-container">
        <input
          ref={inputRef}
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Bir şeyler yazın..."
          disabled={isConnecting}
        />
        <button 
          onClick={handleSendMessage} 
          disabled={isConnecting || !input.trim()}
        >
          {isConnecting ? 'Gönderiliyor...' : 'Gönder'}
        </button>
      </div>
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default ChatInterface; 